import { createShortageProductPointsKey } from 'constants/queryCacheKeys';
import { getShortageProductPoints, ShortageProductPointsParams } from 'domain/stocks';
import { useQuery } from 'react-query';

export const useShortageProductPoints = (params: ShortageProductPointsParams) => {
  return useQuery(createShortageProductPointsKey(params), () => getShortageProductPoints(params));
};
